import * as React from "react";
import {ISvgIconProps} from "@alethio/ui/lib/util/react/SvgIcon";

export interface IRedIconProps extends ISvgIconProps {
}

export class RedIcon extends React.PureComponent<IRedIconProps> {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 65" fill="none">
                <g clipPath="url(#clip0)">
                    <path d="M40.814 65H0V18.2577C0 12.9906 6.8968 11.0066 9.70749 15.4706L40.814 65Z" fill="#D1D3D4"/>
                    <path
                        d="M25.556 40.6959L0 65V18.2577C0 12.9906 6.8968 11.0066 9.70749 15.4706L25.556 40.6959Z"
                        fill="#939598"/>
                    <path
                        d="M0 65V5.19622C0 2.3383 2.3383 0 5.19622 0H27.0676C38.7591 0 44.9945 13.77 37.2711 22.5563L0 65Z"
                        fill="url(#paint0_linear)"/>
                </g>
                <defs>
                    <linearGradient
                        id="paint0_linear" x1="32.1955" y1="1.82236" x2="-15.6433" y2="49.6612"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#B5D034"/>
                        <stop offset="1" stopColor="#61C3AC"/>
                    </linearGradient>
                    <clipPath id="clip0">
                        <rect width="40" height="65" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        );
    }
}
